import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import type { FiltersGroup } from '@sorare/core/src/lib/filters';

import type { FullProps } from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';
import {
  AdvancedPlayerSearch,
  BackendAdvancedPlayerSearch,
} from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';
import {
  scoutingCenterBackendMarketDropdownFilters,
  scoutingCenterMarketDropdownFilters,
} from '@sorare/marketplace/src/searchCommonPlayer/filtersGroup/football';

type Props = Omit<FullProps, 'sport'> & { backendCardFilters: FiltersGroup[] };

export const FootballPlayerSearch = (props: Props) => {
  const {
    flags: { useGraphqlScoutingCenter = false },
  } = useFeatureFlags();
  if (useGraphqlScoutingCenter) {
    return (
      <BackendAdvancedPlayerSearch
        sport={Sport.FOOTBALL}
        defaultHitsPerPage={20}
        dropdownFilters={scoutingCenterBackendMarketDropdownFilters}
        {...props}
      />
    );
  }
  return (
    <AdvancedPlayerSearch
      sport={Sport.FOOTBALL}
      defaultHitsPerPage={20}
      dropdownFilters={scoutingCenterMarketDropdownFilters}
      {...props}
    />
  );
};
